//
// Copyright 2026 DXOS.org
//

import * as parsimmon from 'parsimmon';

export { parsimmon };
